import { LEFT_PANEL_BLOCKS } from "../leftPanelBlocks";

export function LeftPanelCopy({ step }: { step: number }) {
  const block = LEFT_PANEL_BLOCKS[step];
  if (!block) return null;

  return (
    <div className="max-w-[380px]">
      <p className="mb-4 text-[10.5px] font-semibold text-muted-foreground">
        {block.tag}
      </p>
      <h2 className="mb-3.5 text-[38px] leading-[1.08] font-semibold text-foreground">
        {block.headline}
      </h2>
      <p className="mb-6 text-sm leading-relaxed text-muted-foreground">{block.body}</p>
      {block.supportedBy ? (
        <div className="flex flex-col gap-2.5 border-t border-border pt-[18px]">
          <p
            id="welcome-supported-by-label"
            className="text-[10.5px] font-semibold uppercase text-muted-foreground"
          >
            Supported by
          </p>
          <ul
            aria-labelledby="welcome-supported-by-label"
            className="flex flex-wrap items-center gap-x-4 gap-y-2"
          >
            {block.supportedBy.map((sponsor) => (
              <li key={sponsor.name}>
                {sponsor.src ? (
                  <img
                    src={sponsor.src}
                    alt={sponsor.alt}
                    className="h-5 w-auto max-w-[120px] object-contain object-left"
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <span className="text-xs font-medium text-muted-foreground">{sponsor.name}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      ) : block.stats ? (
        <div className="flex flex-col gap-3 border-t border-border pt-[18px]">
          {block.stats.map((stat) => (
            <div key={stat.k} className="flex items-baseline gap-3">
              <span className="font-mono text-lg font-semibold text-foreground">
                {stat.k}
              </span>
              <span className="text-xs text-muted-foreground">{stat.l}</span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
